import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from '../services/permission.service';
import { AuthService } from '../services/auth.service';
import {EModulePermissions, Permission} from '../enums/permission.enum';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(private permissionService: PermissionService,
              private authService: AuthService,
              private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const permissions = route.data.permissions as Array<string>;
    const modulePermission = route.data.modulePermission as EModulePermissions;

    if (!permissions) {
      return true;
    }

    if (state.url === '/') {
      this.redirectToAnotherPageIfRouteNotHasPermission(permissions);
    }

    for (const permission of permissions) {
      if (!this.permissionService.hasPermission(permission)) {
        this.redirectToAnotherPageIfRouteNotHasPermission(permissions);
      }
    }

    if (!this.permissionService.checkModulePermission(modulePermission)) {
      this.redirectToAnotherPageIfRouteNotHasModulePermission(modulePermission);
    }

    if (modulePermission) {
      return true;
    }

    return true;
  }

  // When user try to log in and doesn't have permission for recorder, need to redirect to another page
  private redirectToAnotherPageIfRouteNotHasPermission(permissions: string[]): void {
    const permission = permissions.some(permission => this.permissionService.hasPermission(permission));

    if (!permission) {
      if (this.permissionService.hasPermission(Permission.VIDEO_SHOW)) {
        void this.router.navigateByUrl('/videos');
      }
    }
  }

  private redirectToAnotherPageIfRouteNotHasModulePermission(modulePermission: EModulePermissions): void {
    // Heeft de club geen van beide modules, dan is er geen pagina om naartoe
    // te sturen: /videos verwijst naar /live en /live weer terug naar
    // /videos. Die lus rendert nooit iets en liet een leeg grijs scherm
    // achter (Al-Arabi SC, 22-09-2026). Het inloggen wordt nu al bij de
    // loginpagina geweigerd; dit vangt de sessie op die er al was.
    if (modulePermission && !this.permissionService.heeftPlatformToegang()) {
      this.authService.logout();
      void this.router.navigateByUrl('/auth/login');
      return;
    }

    if (modulePermission === EModulePermissions.VIDEO_STORAGE) {
      void this.router.navigateByUrl('/live');
    } else if (modulePermission === EModulePermissions.SCHEDULING) {
      void this.router.navigateByUrl('/videos');
    }
  }
}
